import { useId } from "react";
import { Check } from "lucide-react";

// Suggest-first text input: known values as tappable chips + a native <datalist>, free text always allowed.
// mode="single" replaces the value; mode="list" toggles the chip inside a comma-separated value.
export default function SuggestInput({ value, onChange, options = [], mode = "single", max = 8, inputProps = {}, testid, emptyHint }) {
  const listId = useId();
  const parts = mode === "list" ? value.split(",").map((s) => s.trim()).filter(Boolean) : [value.trim()];
  const has = (o) => parts.some((p) => p.toLowerCase() === o.toLowerCase());
  const pick = (o) => {
    if (mode === "single") return onChange(has(o) ? "" : o);
    onChange((has(o) ? parts.filter((p) => p.toLowerCase() !== o.toLowerCase()) : [...parts, o]).join(", "));
  };
  const shown = options.slice(0, max);
  return (
    <div>
      {shown.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-1.5" role="group" aria-label="Suggestions — pick one or type your own below" data-testid={`${testid}-suggestions`}>
          {shown.map((o) => <button key={o} type="button" aria-pressed={has(o)} data-testid={`${testid}-suggest-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} onClick={() => pick(o)} className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-bold transition-colors ${has(o) ? "bg-ink text-on-dark border-ink" : "bg-card text-subtle border-border hover:border-accent-400"}`}>{has(o) && <Check size={11} aria-hidden="true" />}{o}</button>)}
          {options.length > max && <span className="text-[11px] text-muted-foreground self-center">+{options.length - max} more via typing</span>}
        </div>
      )}
      <input {...inputProps} list={listId} value={value} onChange={(e) => onChange(e.target.value)} autoComplete="off" />
      <datalist id={listId}>{options.map((o) => <option key={o} value={o} />)}</datalist>
      {emptyHint && shown.length === 0 && <div className="text-[11px] text-muted-foreground mt-1">{emptyHint}</div>}
    </div>
  );
}
